module.exports = __webpack_public_path__ + "static/media/dangerTriangle.b6006131.svg";